module.exports = {"TXTCLI_Play":{"id":"TXTCLI_Play","defaultMessage":"Spiel","flags":["TRACK"],"track":"Play"}}